export default {
    SET_CURRENCY_NAME_SELECT: "setCurrencyNameSelect",
    SET_CLIENT_ID: "setClientId",
    PUSH_TO_PRICE_LISTS: "pushToPriceLists",
    REMOVE__FROM_PRICE_LISTS: "removeFromPriceLists",
    SET_ID_NUMBERS_TYPES_SELECT: "setIdNumbersTypesSelect",
    PUSH_ID_NUMBERS_TYPES_OPTION: "pushIdNumbersTypesOption",
    SET_CURRENT_SA_DEPARTMENT: "setCurrentSaDepartment",
    SET_SELECTED_SA_DEPARTMENT: "setSelectedSaDepartment",
    SET_ERRORS: "setErrors",
    SET_OLD: "setOld",
    SET_VALUES: "setValues",
    PUSH_TO_COUNTRIES_SELECT: "pushToCountriesSelect",
    PUSH_TO_COUNTRIES_PRICELIST_SELECT: "pushToCountriesPriceListSelect"
};
